import { uploadFile } from '/firebaseServices.js';

let currentImageUrl = ''; // Declare this at the top of your script.js file



document.getElementById('imageUpload').addEventListener('change', async function() {
    if (this.files.length > 0) {
        const uploadSuccessIndicator = document.getElementById('uploadSuccess');
        // Clear the check mark
        uploadSuccessIndicator.innerHTML = '&#10003;'; // Keep the check mark but it will be hidden initially
        uploadSuccessIndicator.style.visibility = 'hidden'; // Hide the check mark but reserve the space
        
        // Placeholder for completion animation, then show the check mark
        await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate a brief animation with a timeout
        
        // After the "animation", show the check mark
        uploadSuccessIndicator.style.visibility = 'visible'; // Show the check mark
        
        // Fade in the "Create Mockup" button
        const submitBtn = document.getElementById('submitBtn');
        submitBtn.style.opacity = 0;
        submitBtn.style.display = 'block'; // Make it ready to be faded in
        // Show the "Take Snapshot" button


        let opacity = 0;
        const fadeInInterval = setInterval(() => {
            if (opacity < 1) {
                opacity += 0.05; // Adjust the fade effect
                submitBtn.style.opacity = opacity;
            } else {
                clearInterval(fadeInInterval);
            }
        }, 50); // Timing for the fade effect
    }
});

document.getElementById('submitBtn').addEventListener('click', async function() {
    const input = document.getElementById('imageUpload');

    const file = input.files[0];
    if (file) {
        const creationSuccessIndicator = document.getElementById('creationSuccess');
        // Initially hide the creation success indicator properly
        creationSuccessIndicator.style.visibility = 'hidden';
        
        uploadFile(file).then(async downloadURL => {
            console.log('File uploaded successfully: ', downloadURL);

            currentImageUrl = downloadURL; // Make sure this line is present and correctly setting the URL
            
            
            if (typeof window.applyTexture === 'function') {
                await window.applyTexture(downloadURL);
                console.log('Texture applied from: ', downloadURL);
                // Show check mark next to "Create Mockup" button upon successful model generation
                creationSuccessIndicator.style.visibility = 'visible';

                                // Fade in the "Take Snapshot" button
                                const snapshotBtn = document.getElementById('snapshotBtn');
                                snapshotBtn.style.opacity = 0; // Set initial opacity to 0
                                snapshotBtn.style.display = 'block'; // Make it ready to be faded in
                
                                let snapshotOpacity = 0;
                                const snapshotFadeInInterval = setInterval(() => {
                                    if (snapshotOpacity < 1) {
                                        snapshotOpacity += 0.05; // Adjust the fade effect
                                        snapshotBtn.style.opacity = snapshotOpacity;
                                    } else {
                                        clearInterval(snapshotFadeInInterval);
                                    }
                                }, 50); // Timing for the fade effect



            } else {
                console.error('applyTexture function is not defined. Ensure threejsSetup.js is loaded and correctly defined.');
            }
        }).catch(error => {
            console.error('Error uploading file:', error);
            // Optionally handle upload failure here
        });
    } else {
        alert('Please select a file first.');
    }
});


